export const GET_CATALOG = '[Catalog] List Catalog';
export const GET_CATALOG_SUCCESS = '[Catalog] List Catalog Success';
export const GET_CATALOG_ERROR = '[Catalog] List Catalog Error';

export const SORT_CATALOG = '[Catalog] Sort';
export const RESET_CATALOG_STORE = '[Catalog] Reset Catalog Store';
export const RESET_ARTIST_CATALOG_STORE =
  '[Catalog] Reset Artist Catalog Store';
export const CREATE_COMBINED_CATALOG = '[Catalog] Build Combined Catalog';
